import { useCallback, useMemo, useState } from 'react';
import { TFiltersProps } from '../../components/filters/Filters';
import { ONE_OFF_EVENT_TYPES } from '../../entities/events/shared';
import { TGiftType, useQueryAllOneOffAssemblingGiftsNew } from '../../entities/gifts/queries';
import { isDependant } from '../../entities/recipients/shared';
import { TDependantType, TGiftStatuses, TGiftTypes } from '../../generated/graphql';
import { GiftAssembling, TGiftAssemblingColumnDetails } from './GiftAssembling';

export const subscriptionGiftsAssemblingColumnsDetails: TGiftAssemblingColumnDetails[] = [
  {
    name: 'Todo',
    destinationColumns: [TGiftStatuses.Assembling],
    nextPhase: TGiftStatuses.Assembling,
    id: TGiftStatuses.Todo
  },
  {
    name: 'Assembling',
    destinationColumns: [TGiftStatuses.Todo, TGiftStatuses.Qa],
    nextPhase: TGiftStatuses.Qa,
    id: TGiftStatuses.Assembling
  },
  {
    name: 'QA',
    destinationColumns: [TGiftStatuses.Todo, TGiftStatuses.Assembling, TGiftStatuses.Done],
    nextPhase: TGiftStatuses.Done,
    id: TGiftStatuses.Qa
  },
  {
    name: 'Done',
    destinationColumns: [],
    nextPhase: undefined,
    id: TGiftStatuses.Done
  }
];

export const OneOffGiftsNEW = () => {
  const [giftTypeFilter, setGiftTypeFilter] = useState<TGiftTypes>();
  const [recipientTypeFilter, setRecipientTypeFilter] = useState<TDependantType | 'employee'>();

  const filterMethod = useCallback(
    (gift: TGiftType) => {
      if (giftTypeFilter != null && gift.type !== giftTypeFilter) return false;

      if (recipientTypeFilter != null) {
        const recipient = gift.recipient;
        if (recipient == null) return false;

        if (isDependant(recipient)) {
          if (recipient.type !== recipientTypeFilter) return false;
        } else
          // THIS IS AN EMPLOYEE
          if (recipientTypeFilter !== 'employee') return false;
      }

      return true;
    },
    [giftTypeFilter, recipientTypeFilter]
  );

  const extraFilters = useMemo(() => {
    const filtersList: TFiltersProps['filters'] = [];

    filtersList.push(
      {
        label: 'Event Type',
        name: 'eventType',
        onChange: (v) => {
          setGiftTypeFilter(v != null ? (v as TGiftTypes) : undefined);
        },
        options: Object.entries(ONE_OFF_EVENT_TYPES).map(([key, value]) => ({ label: value, value: key })),
        type: 'singleSelect',
        value: giftTypeFilter
      },
      {
        label: 'Recipient Type',
        name: 'recipientType',
        onChange: (v) => {
          setRecipientTypeFilter(v != null ? (v as TDependantType | 'employee') : undefined);
        },
        options: [
          {
            label: 'Employee',
            value: 'employee'
          },
          {
            label: 'Spouse',
            value: TDependantType.SignificantOther
          },
          {
            label: 'Child',
            value: TDependantType.Child
          },
          {
            label: 'Pet',
            value: TDependantType.Pet
          }
        ],
        type: 'singleSelect',
        value: recipientTypeFilter
      }
    );

    return filtersList;
  }, [giftTypeFilter, recipientTypeFilter]);

  return <GiftAssembling columnsDetails={subscriptionGiftsAssemblingColumnsDetails} extraFilterFunction={filterMethod} extraFilters={extraFilters} query={useQueryAllOneOffAssemblingGiftsNew} isNew={true} />;
};
